import { render, staticRenderFns } from "./TransferTab64_director.vue?vue&type=template&id=42437b39"
import script from "./TransferTab64_director.vue?vue&type=script&lang=js"
export * from "./TransferTab64_director.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports